import { render, staticRenderFns } from "./TrendSales.vue?vue&type=template&id=ee0bfdde&scoped=true&"
import script from "./TrendSales.vue?vue&type=script&lang=js&"
export * from "./TrendSales.vue?vue&type=script&lang=js&"
import style0 from "./TrendSales.vue?vue&type=style&index=0&id=ee0bfdde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0bfdde",
  null
  
)

export default component.exports